module.exports = __webpack_public_path__ + "img/camps.03558d0a.png";